
export const clientStateGetters = {
    landerApiUrl: (state) => state.lander.client.landerApiUrl,
    upsellActionUrl: (state) => state.lander.client.upsellActionUrl,
    busy: (state) => state.lander.client.busy,
    landerLoading: (state) => state.lander.client.loading,
    landerReady: (state) => state.lander.client.ready,
    showProspectForm: (state) => state.lander.client.showProspectForm,
    preAnimCompleted: (state) => state.lander.client.preAnimCompleted,
    spinCompleted: (state) => state.lander.client.spinCompleted,
    exitPopCompleted: (state) => state.lander.client.exitPopCompleted,
    exitPopCancelled: (state) => state.lander.client.exitPopCancelled,
    surveyCompleted: (state) => state.lander.client.surveyCompleted,
    ageVerified: (state) => state.lander.client.ageVerified,
    scrollTrackingPaused: (state) => state.lander.client.scrollTrackingPaused,
    windowSize: (state) => state.lander.client.windowSize,
    virtualOfferCode: (state) => state.lander.client.virtualOfferCode,
    userSubscribed: (state) => state.lander.client.userSubscribed,
    merchantCss: (state) => state.lander.client.merchantCss,
    merchantTheme: (state) => state.lander.client.merchantTheme,
    showTrustPilotBox: (state) => state.lander.client.showTrustPilotBox,
}

export const serverStateGetters = {
    product: (state) => state.lander.server.product,
    lander: (state) => state.lander.server.lander,
    options: (state) => state.lander.server.options,
    offer: (state) => state.lander.server.offer,
    benefits: (state) => state.lander.server.benefits,
    currency: (state) => state.lander.server.currency,
    gateway: (state) => state.lander.server.gateway,
    pixels: (state) => state.lander.server.pixels,
    exitOffer: (state) => state.lander.server.exitOffer,
    drugName: (state) => state.lander.server.drugName,
    merchant: (state) => state.lander.server.merchant,
    gift: (state) => state.lander.server.gift,
    social: (state) => state.lander.server.social,
    info: (state) => state.lander.server.info,
    primary: (state) => state.lander.server.primary,
    spin: (state) => state.lander.server.spin,
    prospect: (state) => state.lander.server.prospect,
    trustPilot: (state) => state.lander.server.trustPilot,
    planTypeLabel: (state) => state.lander.server.planTypeLabel,
}

export const computedGetters = {
    isDomainShifted: (state, getters) => {
        const urlObj = new URL(window.location);
        return getters.lander && getters.lander.domain != urlObj.hostname;
    },
    isEmailLander: (state, getters) => getters.lander && getters.lander.sid && new RegExp("_*eml$").test(getters.lander.sid),
    survey: (state, getters) => getters?.options?.survey == '1' && getters.windowSize.innerWidth < 751 && !getters.surveyCompleted,
    showSocialButtons: (state, getters) => !getters.authToken && !getters.prospect?.locked && getters.social?.showButtons,
    firstOrderBenefit: (state, getters) => getters.benefits.firstorder
}
